import type { z } from 'zod';
import { PositionSchema } from '@axiom/validation';

export const OpportunityProfilePositionsDescriptionFormSchema =
  PositionSchema.pick({
    description: true,
  });

export type OpportunityProfilePositionsDescriptionFormSchemaType = z.infer<
  typeof OpportunityProfilePositionsDescriptionFormSchema
>;
